import utils from "utils";
import { apiCall } from "./apiCall";
import { httpClient } from "./httpClient";

const getSettings = async (props) => {
  const payload = {
    settingid: props?.settingid,
  };

  if (payload.settingid) {
    const apiCallRes = await apiCall({
      data: payload,
      url: "/settings",
      method: "get",
    });
    return apiCallRes;
  }

  return { code: "-2", message: "data missing" };
};

const updateSetting = async (props) => {
  const payload = {
    settingid: props?.settingid,
    settingvalue: props?.settingvalue,
  };

  if (payload.settingid) {
    const apiCallRes = await apiCall({
      data: payload,
      url: "/settings/update",
      method: "post",
    });
    return apiCallRes;
  }

  return { code: "-2", message: "data missing" };
};

const getPermission = async (props) => {
  return apiCall({
    data: props,
    url: "/permission",
    method: "get",
  });
};

const getPermissionPermissionsList = async () => {
  return apiCall({
    data: {},
    url: "/permission/permissions/list",
    method: "get",
  });
};

const getPermissionPermissionsSelected = async (props) => {
  const payload = {
    permissionid: props?.permissionid,
  };

  // if (payload.permissionid) {
  const apiCallRes = await apiCall({
    data: payload,
    url: "/permission/permissions/selected",
    method: "get",
  });
  return apiCallRes;
  // }

  // return { code: "-2", message: "data missing" };
};

const getPayments = async (props) => {
  const payload = {
    dealerid: props?.dealerid,
    page: props?.page,
    searchtxt: props?.searchtxt,
  };

  // if (payload?.dealerid) {
  return apiCall({
    data: payload,
    url: "/payments",
    method: "get",
  });
  // }
  // return { code: "-2", message: "data missing" };
};

const getPaymentsin = async (props) => {
  const payload = {
    dealerid: props?.dealerid,
    page: props?.page,
    searchtxt: props?.searchtxt,
  };
  return apiCall({
    data: payload,
    url: "/paymentsin",
    method: "get",
  });
};

const getCovertype = async () => {
  return apiCall({
    data: {},
    url: "/covertype",
    method: "get",
  });
};

const getCovertypeAll = async (props) => {
  return apiCall({
    data: props,
    url: "/covertype/all",
    method: "get",
  });
};

// const getPurchaseduration = async () => {
//   return apiCall({
//     data: {},
//     url: "/purchaseduration",
//     method: "get",
//   });
// };

const getUsers = async (props) => {
  return apiCall({
    data: props,
    url: "/users",
    method: "get",
  });
};

const getSchedule = async (props) => {
  return apiCall({
    data: props,
    url: "/schedule",
    method: "get",
  });
};

const getCars = async (props) => {
  return apiCall({
    data: props,
    url: "/cars",
    method: "get",
  });
};

const getGroups = async (props) => {
  return apiCall({
    data: props,
    url: "/groups",
    method: "get",
  });
};

const getGroupmembers = async (props) => {
  const payload = {
    page: props?.page,
  };

  if (!props?.groupid && props?.group_selected_list) {
    payload.group_selected_list = props.group_selected_list;
  }

  if (props?.searchtxt) {
    payload.searchtxt = props.searchtxt;
  }

  if (props?.groupid) {
    payload.groupid = props.groupid;
  }

  return apiCall({
    data: payload,
    url: "/groupmembers",
    method: "get",
  });
};

const getPricing = async (props) => {
  return apiCall({
    data: props,
    url: "/pricing",
    method: "get",
  });
};

const login = async (props) => {
  const payload = {
    username: props?.username,
    password: props?.password,
  };

  if (payload.username && payload.password) {
    const apiCallRes = await apiCall({
      data: payload,
      url: "/login",
      method: "post",
    });
    httpClient.setAuthorization(apiCallRes?.data?.accesstoken || "");
    return apiCallRes;
  }

  return { code: "-2", message: "please enter username and password" };
};

const getClaims = async (props) => {
  const payload = {
    dealerid: props?.dealerid,
    searchtxt: props?.searchTxt || "",
    limit: props?.limitId || "",
    page: props?.page || "",
  };

  if (payload.dealerid !== null && payload.dealerid !== undefined) {
    const apiCallRes = await apiCall({
      data: payload,
      url: "/claims",
      method: "get",
    });
    return apiCallRes;
  }

  return { code: "-2", message: "data missing" };
};

const getInvoices = async (props) => {
  console.log("getInvoices", props);

  const payload = {
    date: props?.date,
    dealerid: props?.dealerid,
    searchtxt: props?.searchTxt || "",
    limit: props?.limitId || "",
    page: props?.page || "",
  };

  return apiCall({
    data: payload,
    url: "/invoices",
    method: "get",
  });
};

const getInvoicesTotals = async (props) => {
  const payload = {
    date: props?.date,
    dealerid: props?.dealerid,
    searchtxt: props?.searchTxt || "",
    limit: props?.limitId || "",
  };

  return apiCall({
    data: payload,
    url: "/invoices/totals",
    method: "get",
  });
};

const getVat = async (props) => {
  return apiCall({
    data: {},
    url: "/vat",
    method: "get",
  });
};

const getDealers = async (props) => {
  return apiCall({
    data: {},
    url: "/dealers",
    method: "get",
  });
};

const getStatus = async (props) => {
  const payload = {
    dealerid: props?.dealerid,
  };

  if (payload.dealerid || payload.dealerid === 0) {
    const apiCallRes = await apiCall({
      data: payload,
      url: "/status_au",
      method: "get",
    });
    return apiCallRes;
  }

  return { code: "-2", message: "data missing" };
};

const getStatements = async (props) => {
  const payload = {
    dealerid: props?.dealerid,
    page: props?.page || 1,
  };

  if (payload.dealerid || payload.dealerid === 0) {
    const apiCallRes = await apiCall({
      data: payload,
      url: "/statements",
      method: "get",
    });
    return apiCallRes;
  }

  return { code: "-2", message: "data missing" };
};

const getAgreements = async (props) => {
  const payload = {
    dealerid: props?.dealerid,
    searchtxt: props?.searchTxt || "",
    limit: props?.limitId || "",
    page: props?.page || "",
  };

  if (
    payload.dealerid !== undefined &&
    payload.dealerid !== null &&
    payload.dealerid !== ""
  ) {
    const apiCallRes = await apiCall({
      data: payload,
      url: "/agreements",
      method: "get",
    });
    return apiCallRes;
  }

  return { code: "-2", message: "data missing" };
};

const getPolicyTypes = async (props) => {
  const payload = {
    dealerid: props?.dealerid,
  };

  if (payload.dealerid) {
    return apiCall({
      data: payload,
      url: "/policytypes",
      method: "get",
    });
  }
  return { code: "-2", message: "data missing" };
};

const getAddress = async (props) => {
  let errMsg = "";
  const payload = {
    postcode: props?.postcode,
  };

  if (!payload.postcode) {
    errMsg = "please enter postcode";
  }

  if (errMsg === "") {
    return apiCall({
      data: payload,
      url: "/address",
      method: "get",
    });
  }
  return { code: "-2", message: errMsg || "data missing" };
};

const getVehicledata = async (props) => {
  const payload = {
    regnumber: props?.regnumber,
  };

  if (payload.regnumber) {
    return apiCall({
      data: payload,
      url: "/vehicledata",
      method: "get",
    });
  }
  return { code: "-2", message: "data missing" };
};

const getFueltype = async (props) => {
  return apiCall({
    data: {},
    url: "/fueltype",
    method: "get",
  });
};

const getFueltypeexists = async (props) => {
  const payload = {
    fueltype: props?.fueltype,
  };

  if (payload.fueltype) {
    return apiCall({
      data: payload,
      url: "/fueltypeexists",
      method: "get",
    });
  }
  return { code: "-2", message: "data missing" };
};

const addFueltype = async (props) => {
  const payload = {
    fueltype: props?.fueltype,
  };

  if (payload.fueltype) {
    return apiCall({
      data: payload,
      url: "/fueltype",
      method: "post",
    });
  }
  return { code: "-2", message: "data missing" };
};

const getPurchaseduration = async (props) => {
  const payload = {
    coverid: props?.coverid,
    dealerid: props?.dealerid,
  };

  if (payload.coverid) {
    return apiCall({
      data: payload,
      url: "/purchaseduration",
      method: "get",
    });
  }
  return { code: "-2", message: "data missing" };
};

const getPurchasedurationAll = async (props) => {
  return apiCall({
    data: props,
    url: "/purchaseduration/all",
    method: "get",
  });
};

const getClaimamounts = async (props) => {
  const payload = {
    coverid: props?.coverid,
    dealerid: props?.dealerid,
    durationid: props?.durationid,
  };

  if (payload.coverid) {
    return apiCall({
      data: payload,
      url: "/claimamounts",
      method: "get",
    });
  }
  return { code: "-2", message: "data missing" };
};

const addAgreement = async (props) => {
  return apiCall({
    data: props,
    url: "/agreements/add/",
    method: "post",
  });
};

const updateAgreement = async (props) => {
  return apiCall({
    data: props,
    url: "/agreement/update/",
    method: "post",
  });
};

const getClaimHistory = async (props) => {
  const payload = {
    claimid: props?.claimid,
  };

  if (payload.claimid) {
    return apiCall({
      data: props,
      url: "/claimhistory",
      method: "get",
    });
  }
  return { code: "-2", message: "data missing" };
};

const getHaspermission = async (props) => {
  const payload = {
    permvalue: props?.permvalue,
  };

  if (payload.permvalue) {
    return apiCall({
      data: props,
      url: "/haspermission",
      method: "get",
    });
  }
  return { code: "-2", message: "data missing" };
};

const getInvoicedates = async (props) => {
  return apiCall({
    data: {},
    url: "/invoicedates",
    method: "get",
  });
};

const updateInvoicepaid = async (props) => {
  const payload = {
    invoiceid: props?.invoiceid,
  };

  if (props?.action) {
    payload.action = props.action;
  }

  if (payload.invoiceid) {
    return apiCall({
      data: payload,
      url: "/invoiceupdate/paid",
      method: "post",
    });
  }
  return { code: "-2", message: "data missing" };
};

const runagainInvoice = async (props) => {
  const payload = {
    invoiceid: props?.invoiceid,
    invoicenumber: props?.invoicenumber,
  };

  if (props?.action) {
    payload.action = props.action;
  }

  if (payload.invoiceid) {
    return apiCall({
      data: payload,
      url: "/invoice/runagian",
      method: "post",
    });
  }
  return { code: "-2", message: "data missing" };
};



const addPaymentsin = async (props) => {
  return apiCall({
    data: props,
    url: "/paymentsin/add",
    method: "post",
  });
};

const addPaymentsout = async (props) => {
  return apiCall({
    data: props,
    url: "/paymentsout/add",
    method: "post",
  });
};

const updatePaymentsout = async (props) => {
  return apiCall({
    data: props,
    url: "/paymentsout/update",
    method: "post",
  });
};

const updatePaymentsin = async (props) => {
  return apiCall({
    data: props,
    url: "/paymentsin/update",
    method: "post",
  });
};

const getReturns = async (props) => {
  const payload = {
    dealerid: props?.dealerid,
    page: props?.page,
  };

  if (props?.dateStart && props?.dateEnd) {
    payload.datestart = props?.dateStart;
    payload.dateend = props?.dateEnd;
  }

  if (props?.datestart) {
    payload.datestart = utils.dateToDateInput(props?.datestart);
  }
  if (props?.dateend) {
    payload.dateend = utils.dateToDateInput(props?.dateend);
  }

  // if (payload?.dealerid) {
  return apiCall({
    data: payload,
    url: "/returns",
    method: "get",
  });
  // }
  // return { code: "-2", message: "data missing" };
};

const getInvoiceprint = async (props) => {
  console.log("getInvoiceprint", props);

  // httpClient.interceptors.request.use((c) => (c.timeout = 15000));

  const payload = {
    // invoiceid: props?.invoiceid,
    date: props?.date,
    dealerid: props?.dealerid,
    searchtxt: props?.searchTxt || "",
    limit: props?.limitId || "",
    // page: props?.page || "",
  };

  if (props?.isallprint) {
    payload.isallprint = true;
  } else {
    payload.invoiceid = props?.invoiceid;
  }

  if (payload?.invoiceid || payload?.isallprint) {
    const cc = httpClient.interceptors.request.use((config) => {
      config.timeout = 0;
      return config;
    });

    const res = await apiCall({
      data: payload,
      url: "/invoice/print",
      method: "get",
    });

    httpClient.interceptors.request.eject(cc);
    return res;
  }
  return { code: "-2", message: "data missing" };
};

const getAgreementPrint = async (props) => {
  const payload = {
    policyid: props?.policyid,
  };

  if (payload.policyid) {
    return apiCall({
      data: payload,
      url: "/agreement/print",
      method: "get",
    });
  }
  return { code: "-2", message: "data missing" };
};

const getClaimPrint = async (props) => {
  const payload = {
    claimid: props?.claimid,
  };

  if (payload.claimid) {
    return apiCall({
      data: payload,
      url: "/claim/print",
      method: "get",
    });
  }
  return { code: "-2", message: "data missing" };
};

const updateClaimsstate = async (props) => {
  const payload = {
    claimid: props?.claimid,
    stateid: props?.stateid,
    description: props?.description || "",
  };

  if (payload.claimid && payload.stateid) {
    return apiCall({
      data: payload,
      url: "/claimsstate/update",
      method: "post",
    });
  }
  return { code: "-2", message: "data missing" };
};

const sentClaimnotifyOffice = async (props) => {
  const payload = {
    claimid: props?.claimid,
    // stateid: props?.stateid,
    description: props?.description || "",
    claimnumber: props?.claimnumber || "",
  };
  let errMsg = "";

  if (!errMsg && !payload.description) {
    errMsg = "please enter description";
  }

  if (!errMsg && !payload.claimid) {
    errMsg = "claimid missing";
  }

  if (!errMsg && !payload.claimnumber) {
    errMsg = "claimnumber missing";
  }

  if (!errMsg) {
    return apiCall({
      data: payload,
      url: "/claim/notify/office",
      method: "post",
    });
  }
  return { code: "-2", message: errMsg || "data missing" };
};

const sentClaimnotifyCustomer = async (props) => {
  console.log("sentClaimnotifyCustomer props", props);

  let errMsg = "";
  const payload = {
    claimid: props?.claimid,
    mobile: props?.mobile,
    email: props?.email,
    // stateid: props?.stateid,
    description: props?.description || "",
    company: props?.company || "",
    claimnumber: props?.claimnumber || "",
  };

  if (
    props?.type === "mobile" &&
    !errMsg &&
    !utils.validateMobileNum(payload.mobile)
  ) {
    errMsg = "please enter valid mobile number";
  }

  if (
    props?.type === "email" &&
    !errMsg &&
    !utils.validateEmail(payload.email)
  ) {
    errMsg = "please enter valid email";
  }

  if (!payload.claimid) {
    errMsg = "claim id missing";
  }

  if (errMsg === "") {
    return apiCall({
      data: payload,
      url: "/claim/notify/customer",
      method: "post",
    });
  }
  return { code: "-2", message: errMsg };
};

const sentClaimnotifyAcmanager = async (props) => {
  console.log("sentClaimnotifyAcmanager props", props);
  let errMsg = "";
  const payload = props;

  // {
  //   claimid: props?.claimid,
  //   // mobile: props?.mobile,
  //   // email: props?.email,
  //   // stateid: props?.stateid,
  //   // description: props?.description || "",
  // };

  // if (utils.validateMobileNum(payload.mobile)) {
  //   errMsg = "please enter valid mobile number";
  // }

  if (!payload.claimid) {
    errMsg = "data missing";
  }

  if (errMsg === "") {
    return apiCall({
      data: payload,
      url: "/claim/notify/acmanager",
      method: "post",
    });
  }
  return { code: "-2", message: errMsg };
};

const getClaimCustomer = async (props) => {
  const payload = {
    claimid: props?.claimid,
  };

  if (payload.claimid) {
    return apiCall({
      data: payload,
      url: "/claim/customer",
      method: "get",
    });
  }
  return { code: "-2", message: "data missing" };
};

const getClaimSearchvrm = async (props) => {
  const payload = {
    searchtxt: props?.searchTxt || "",
  };

  if (payload.searchtxt) {
    return apiCall({
      data: payload,
      url: "/claim/searchvrm",
      method: "get",
    });
  }
  return { code: "-2", message: "please enter search text" };
};

const addClaim = async (props) => {
  return apiCall({
    data: props,
    url: "/claim/add",
    method: "post",
  });
};

const getClaim = async (props) => {
  const payload = {
    claimid: props?.claimid,
  };

  if (payload.claimid) {
    return apiCall({
      data: payload,
      url: "/claim",
      method: "get",
    });
  }
  return { code: "-2", message: "data missing" };
};

const updateClaim = async (props) => {
  const payload = props;

  if (payload.claimid) {
    return apiCall({
      data: payload,
      url: "/claim/update",
      method: "post",
    });
  }
  return { code: "-2", message: "data missing" };
};

const getClaimNotifyAcmanger = async (props) => {
  const payload = {
    claimid: props?.claimid,
  };

  if (payload.claimid) {
    return apiCall({
      data: payload,
      url: "/claim/notify/acmanger",
      method: "get",
    });
  }
  return { code: "-2", message: "data missing" };
};

const updatePermission = async (props) => {
  const payload = {
    perm_id: props?.perm_id,
    permissionname: props?.permissionname,
    active: props?.active,
    permissionitems: props?.permissionitems,
  };

  if (payload.perm_id) {
    return apiCall({
      data: payload,
      url: "/permission/update",
      method: "post",
    });
  }
  return { code: "-2", message: "data missing" };
};

const addPermission = async (props) => {
  const payload = {
    permissionname: props?.permissionname,
    active: props?.active,
    permissionitems: props?.permissionitems,
  };

  if (payload?.permissionname) {
    return apiCall({
      data: payload,
      url: "/permission/add",
      method: "post",
    });
  }
  return { code: "-2", message: "data missing" };
};

const addSchedule = async (props) => {
  const payload = props;

  if (payload?.schedulename) {
    return apiCall({
      data: payload,
      url: "/schedule/add",
      method: "post",
    });
  }
  return { code: "-2", message: "data missing" };
};

const updateSchedule = async (props) => {
  const payload = props;

  if (payload?.id) {
    return apiCall({
      data: payload,
      url: "/schedule/update",
      method: "post",
    });
  }
  return { code: "-2", message: "data missing" };
};

const deleteSchedule = async (props) => {
  const payload = {
    id: props?.id,
  };

  if (payload?.id) {
    return apiCall({
      data: payload,
      url: "/schedule/delete",
      method: "post",
    });
  }
  return { code: "-2", message: "data missing" };
};

const addDuration = async (props) => {
  const payload = props;
  let errMsg = "";

  if (!payload?.durationtype) {
    errMsg = "please select duration type";
  }

  if (!payload?.durationvalue) {
    errMsg = "please enter duration value";
  }

  if (!errMsg) {
    return apiCall({
      data: payload,
      url: "/duration/add",
      method: "post",
    });
  }

  return { code: "-2", message: errMsg || "data missing" };
};

const updateDuration = async (props) => {
  const payload = props;
  let errMsg = "";

  if (!payload?.durationid) {
    errMsg = "data missing";
  }

  if (!payload?.durationtype) {
    errMsg = "please select duration type";
  }

  if (!payload?.durationvalue) {
    errMsg = "please enter duration value";
  }

  if (!errMsg) {
    return apiCall({
      data: payload,
      url: "/duration/update",
      method: "post",
    });
  }

  return { code: "-2", message: errMsg || "data missing" };
};

const deleteDuration = async (props) => {
  const payload = {
    durationid: props?.durationid,
  };

  if (payload?.durationid) {
    return apiCall({
      data: payload,
      url: "/duration/delete",
      method: "post",
    });
  }
  return { code: "-2", message: "data missing" };
};

const getPurchaselimit = async (props) => {
  return apiCall({
    data: props,
    url: "/purchaselimit",
    method: "get",
  });
};

const addPurchaselimit = async (props) => {
  const payload = {
    purchaselimitamount: props?.purchaselimitamount,
  };

  if (payload?.purchaselimitamount) {
    return apiCall({
      data: payload,
      url: "/purchaselimit/add",
      method: "post",
    });
  }
  return { code: "-2", message: "data missing" };
};

const updatePurchaselimit = async (props) => {
  const payload = {
    purchaselimitid: props?.purchaselimitid,
    purchaselimitamount: props?.purchaselimitamount,
  };

  if (payload?.purchaselimitid) {
    return apiCall({
      data: payload,
      url: "/purchaselimit/update",
      method: "post",
    });
  }
  return { code: "-2", message: "data missing" };
};

const addCovertype = async (props) => {
  const payload = {
    covertype: props?.covertype,
  };

  if (payload?.covertype) {
    return apiCall({
      data: payload,
      url: "/covertype/add",
      method: "post",
    });
  }
  return { code: "-2", message: "data missing" };
};

const updateCovertype = async (props) => {
  const payload = {
    coverid: props?.coverid,
    covertype: props?.covertype,
  };

  if (payload?.coverid) {
    return apiCall({
      data: payload,
      url: "/covertype/update",
      method: "post",
    });
  }
  return { code: "-2", message: "data missing" };
};

const getCommissionsheetRegMan = async (props) => {
  const payload = { page: props?.page };
  return apiCall({
    data: payload,
    url: "/commissionsheet/regionalmanagers",
    method: "get",
  });
};

const getCommissionsheet = async (props) => {
  const payload = {
    datestart: props?.datestart,
    dateend: props?.dateend,
    regmanagerid: props?.regmanagerid,
    // page: props?.page,
  };

  if (payload?.regmanagerid) {
    return apiCall({
      data: payload,
      url: "/commissionsheet",
      method: "get",
    });
  }

  return { code: "-2", message: "data missing" };
};

const addPricing = async (props) => {
  const payload = props;
  let errMsg = "";

  if (!errMsg && !utils.validateEmail(payload?.email)) {
    errMsg = "please enter valid email";
  }

  if (!errMsg) {
    return apiCall({
      data: payload,
      url: "/pricing/add",
      method: "post",
    });
  }
  return { code: "-2", message: errMsg || "data missing" };
};

const updatePricing = async (props) => {
  const payload = props;
  let errMsg = "";

  if (!payload.id) {
    errMsg = "data missing";
  }

  if (!errMsg && !utils.validateEmail(payload?.email)) {
    errMsg = "please enter valid email";
  }

  if (!errMsg) {
    return apiCall({
      data: payload,
      url: "/pricing/update",
      method: "post",
    });
  }
  return { code: "-2", message: errMsg || "data missing" };
};

const uploadDocument = async (props) => {
  let errMsg = "";
  if (!errMsg && !props?.file) {
    errMsg = "No file selected";
  }

  if (!errMsg) {
    const cc = httpClient.interceptors.request.use((config) => {
      config.headers["timeout"] = 20000;
      config.headers["Content-Type"] = props?.file?.type;
      config.headers["X-File-Name"] = props?.file?.name;
      return config;
    });
    const res = await apiCall({
      data: props?.file,
      url: "/document/upload",
      method: "post",
    });

    httpClient.interceptors.request.eject(cc);
    return res;
  }
  return { code: "-2", message: errMsg || "data missing" };
};

const downloadDocument = async (props) => {
  let errMsg = "";
  const payload = { document_name: props?.document_name };

  if (!payload?.document_name) {
    errMsg = "please select document";
  }

  if (!errMsg) {
    return apiCall({
      data: payload,
      url: "/document/download",
      method: "get",
    });
  }

  return { code: "-2", message: errMsg || "data missing" };
};

const getDocuments = async (props) => {
  return apiCall({
    data: {},
    url: "/documents",
    method: "get",
  });
};

const deleteDocument = async (props) => {
  let errMsg = "";
  const payload = {
    documentid: props?.documentid,
    document_name: props?.document_name,
  };

  if (!payload?.document_name || !payload?.documentid) {
    errMsg = "please select document";
  }

  if (!errMsg) {
    return apiCall({
      data: payload,
      url: "/document/delete",
      method: "post",
    });
  }
  return { code: "-2", message: errMsg || "data missing" };
};

const updateGroup = async (props) => {
  const payload = props;
  if (payload?.groupid) {
    return apiCall({
      data: payload,
      url: "/group/update",
      method: "post",
    });
  }
  return { code: "-2", message: "data missing" };
};

const addGroup = async (props) => {
  let errMsg = "";
  const payload = props;

  if (!payload?.groupname) {
    errMsg = "please enter groupname";
  }

  if (!errMsg) {
    return apiCall({
      data: payload,
      url: "/group/add",
      method: "post",
    });
  }
  return { code: "-2", message: errMsg || "data missing" };
};

const getUsersGroupassociation = async (props) => {
  return apiCall({
    data: { userid: props.userid || "" },
    url: "/users/groupassociation",
    method: "get",
  });
};

const addUser = async (props) => {
  let errMsg = "";
  const payload = props;

  if (!errMsg && !utils.validateEmail(payload.email)) {
    errMsg = "please enter valid Email";
  }

  if (!errMsg && !utils.validateMobileNum(payload.phonemobile)) {
    errMsg = "please enter valid mobile number";
  }

  if (!errMsg && !utils.validateUserAppCode(payload?.appcode)) {
    errMsg = "please enter valid appcode";
  }

  if (!errMsg) {
    return apiCall({
      data: payload,
      url: "/user/add",
      method: "post",
    });
  }
  return { code: "-2", message: errMsg || "data missing" };
};

const updateUser = async (props) => {
  let errMsg = "";
  const payload = props;

  // if (!payload?.groupname) {
  //   errMsg = "please enter groupname";
  // }

  if (!errMsg && !utils.validateEmail(payload.email)) {
    errMsg = "please enter valid Email";
  }

  if (!errMsg && !utils.validateMobileNum(payload.phonemobile)) {
    errMsg = "please enter valid mobile number";
  }

  if (!errMsg && !utils.validateUserAppCode(payload?.appcode)) {
    errMsg = "please enter valid appcode";
  }

  if (!errMsg) {
    return apiCall({
      data: payload,
      url: "/user/update",
      method: "post",
    });
  }
  return { code: "-2", message: errMsg || "data missing" };
};

const logout = async () => {
  const apiCallRes = await apiCall({
    data: {},
    url: "/logout",
    method: "post",
  });
  httpClient.setAuthorization("");
  return apiCallRes;
};

const getPricingexception = async (props) => {
  let errMsg = "";
  const payload = { dealerid: props.dealerid };

  if (!payload.dealerid) {
    errMsg = "please select dealer";
  }

  if (!errMsg) {
    return apiCall({
      data: payload,
      url: "/pricingexception",
      method: "get",
    });
  }
  return { code: "-2", message: errMsg || "data missing" };
};

const updatePricingexception = async (props) => {
  let errMsg = "";
  const payload = props;

  if (!payload?.dealerid) {
    errMsg = "please select dealer";
  }

  if (!errMsg) {
    return apiCall({
      data: payload,
      url: "/pricingexception/update",
      method: "post",
    });
  }
  return { code: "-2", message: errMsg || "data missing" };
};

const getHomeData = async (props) => {
  let errMsg = "";
  const payload = props;

  if (!errMsg && !payload?.datestart) {
    errMsg = "please select start date";
  }
  if (!errMsg && !payload?.dateend) {
    errMsg = "please select end date";
  }

  if (!errMsg && !payload?.dealerid) {
    errMsg = "please select dealer";
  }

  if (!errMsg) {
    return apiCall({
      data: payload,
      url: "/home",
      method: "get",
    });
  }
  return { code: "-2", message: errMsg || "data missing" };
};

const deleteAgreement = async (props) => {
  let errMsg = "";
  const payload = {
    policyid: props?.policyid,
    policynumber: props?.policynumber,
  };

  if (!errMsg && !payload?.policyid) {
    errMsg = "please select agreement";
  }

  if (!errMsg) {
    return apiCall({
      data: payload,
      url: "/agreement/delete",
      method: "post",
    });
  }
  return { code: "-2", message: errMsg || "data missing" };
};

const sendemailAgreement = async (props) => {
  let errMsg = "";
  const payload = {
    policyid: props?.policyid,
    policynumber: props?.policynumber,
    to: props?.to,
  };

  if (!errMsg && !payload?.policyid) {
    errMsg = "please select agreement";
  }

  if (!errMsg) {
    return apiCall({
      data: payload,
      url: "/agreement/sendemail/",
      method: "post",
    });
  }
  return { code: "-2", message: errMsg || "data missing" };
};

const forgotpassword = async (props) => {
  let errMsg = "";
  const payload = { email: props?.email };

  if (!errMsg && !payload?.email) {
    errMsg = "please enter valid email";
  }

  if (!errMsg) {
    return apiCall({
      data: payload,
      url: "/forgotpassword",
      method: "post",
    });
  }
  return { code: "-2", message: errMsg || "data missing" };
};

const resetpassword = async (props) => {
  let errMsg = "";
  const payload = {
    password: props?.password,
    cpassword: props?.cpassword,
    token: props?.token,
  };

  if (!errMsg && !payload?.token) {
    errMsg = "reset link is not valid";
  }

  if (!errMsg && !payload?.password) {
    errMsg = "please enter password";
  }

  if (!errMsg && payload?.password !== payload?.cpassword) {
    errMsg = "password and confirm password not match";
  }

  if (!errMsg) {
    return apiCall({
      data: payload,
      url: "/resetpassword",
      method: "post",
    });
  }
  return { code: "-2", message: errMsg || "data missing" };
};

const getCommissionRule = async (props) => {
  let errMsg = "";
  const payload = {
    userid: props?.userid,
  };

  if (!errMsg && !payload?.userid) {
    errMsg = "please select account";
  }

  if (!errMsg) {
    return apiCall({
      data: payload,
      url: "/commissionrule",
      method: "get",
    });
  }
  return { code: "-2", message: errMsg || "data missing" };
};

const updateCommissionrules = async (props) => {
  let errMsg = "";
  const payload = props;

  if (!errMsg && !payload?.userid) {
    errMsg = "please select account";
  }

  if (!errMsg) {
    return apiCall({
      data: payload,
      url: "/commissionrules/update",
      method: "post",
    });
  }
  return { code: "-2", message: errMsg || "data missing" };
};

const deleteClaim = async (props) => {
  const payload = {
    claimid: props?.claimid,
    claimnumber: props?.claimnumber,
  };

  if (payload.claimid && payload.claimnumber) {
    return apiCall({
      data: payload,
      url: "/claim/delete",
      method: "post",
    });
  }
  return { code: "-2", message: "data missing" };
};

export const api = {
  getSettings,
  updateSetting,
  getPermission,
  getPayments,
  getPaymentsin,
  getCovertype,
  // getPurchaseduration,
  getUsers,
  getSchedule,
  getCars,
  getGroupmembers,
  getGroups,
  addGroup,
  updateGroup,
  getPricing,
  login,
  getClaims,
  getInvoices,
  getVat,
  getDealers,
  getStatus,
  getStatements,
  getAgreements,
  getPolicyTypes,
  getAddress,
  getVehicledata,
  getFueltype,
  getFueltypeexists,
  addFueltype,
  getPurchaseduration,
  getClaimamounts,
  addAgreement,
  updateAgreement,
  getClaimHistory,
  getHaspermission,
  getInvoicedates,
  updateInvoicepaid,
  runagainInvoice,
  addPaymentsin,
  addPaymentsout,
  updatePaymentsout,
  updatePaymentsin,
  getReturns,
  getInvoiceprint,
  updateClaimsstate,
  sentClaimnotifyCustomer,
  sentClaimnotifyOffice,
  sentClaimnotifyAcmanager,
  getClaimCustomer,
  getClaimSearchvrm,
  addClaim,
  getClaim,
  updateClaim,
  getAgreementPrint,
  getPurchasedurationAll,
  getCovertypeAll,
  getClaimNotifyAcmanger,
  getInvoicesTotals,
  getPermissionPermissionsList,
  getPermissionPermissionsSelected,
  updatePermission,
  addSchedule,
  updateSchedule,
  deleteSchedule,
  addDuration,
  updateDuration,
  deleteDuration,
  getPurchaselimit,
  addPurchaselimit,
  updatePurchaselimit,
  addCovertype,
  updateCovertype,
  getCommissionsheetRegMan,
  getCommissionsheet,
  addPricing,
  updatePricing,
  uploadDocument,
  downloadDocument,
  getDocuments,
  deleteDocument,
  addUser,
  updateUser,
  getUsersGroupassociation,
  logout,
  getPricingexception,
  updatePricingexception,
  addPermission,
  getHomeData,
  deleteAgreement,
  sendemailAgreement,
  forgotpassword,
  resetpassword,
  getCommissionRule,
  updateCommissionrules,
  getClaimPrint,
  deleteClaim,
};
